







































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import i18n from "@/i18n";
// types
import { Cultures, SelectOption, UserDetailsModel } from "@/services/users/types";
// validation
import { detailsValidators } from "@/components/users/validators";
import validate from "@/directives/validate";
import { getTimeZones } from "@/services/timeZones/timeZoneService";
import { TimeZone } from "@/services/timeZones/types";
import vSelect from "vue-select";
import { getEditorProfiles } from "@/services/editorProfiles/editorProfilesService";
import { resetPassword } from "@/services/security/authService";
import { Getter } from "vuex-class";
import { CurrentUser } from "@/store/authentication/types";

const namespace: string = "authentication";
@Component({
    components: {
        vSelect
    },
    directives: {
        validate
    }
})
export default class UserDetails extends Vue {
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
    @Prop() availableRoles!: string[];
    @Prop() editMode!: boolean
    @Prop() user!: UserDetailsModel;
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localUser = { roles: [] as string[] } as UserDetailsModel;
    editPassword = false;
    validators = detailsValidators;
    passwordFieldType = "password";
    timeZones = [] as TimeZone[];
    selectedTimeZone = { id: "", displayName: "" } as TimeZone;
    cultures = [] as any[];
    editorProfiles = [] as SelectOption[];
    emailResp = i18n.t("");
    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
        const currentUser: CurrentUser = this.getCurrentUser;
        this.fetchData();

        if (!this.editMode) {
            this.localUser.roles.push("Editor");
            this.localUser.cultureCode = currentUser.cultureCode;
        } else {
            this.validators.email.active = false;
        }
    }

    // watchers
    @Watch("user")
    onUserChanged() {
        this.localUser = this.user;
        this.setTimeZone();
    }

    // computed
    get editPasswordLabel() {
        return this.editPassword ? i18n.t("users.hidePassword") : i18n.t("users.editPassword");
    }

    get roles(): any[] {
        if (!this.localUser || !this.localUser.roles || this.localUser.roles.length === 0) {
            return this.availableRoles.map(x => {
                return { name: x, selected: false };
            });
        }
        return [...new Set([...this.localUser.roles, ...this.availableRoles])]
            .sort()
            .map(x => {
                return { name: x, selected: this.localUser.roles.includes(x) };
            });
    }

    get goToEditorProfile() {
        if (!this.localUser.editorProfileId) {
            return "#";
        }
        return { name: "EditorProfileFormUpdate", params: { editorProfileId: this.localUser.editorProfileId } };
    }

    // methods
    async fetchData() {
        getTimeZones().then(response => {
            this.timeZones = response;
            this.setTimeZone();
        });
        this.cultures = Cultures
            .map(cul => ({ text: i18n.t(`languages.${cul.text}`), value: cul.code }));

        getEditorProfiles().then(response => {
            this.editorProfiles = response.map(x => { return { text: x.name, value: x.id } as SelectOption; });
            if (!this.localUser.editorProfileId) {
                const defaultEditorProfile: SelectOption | undefined = this.editorProfiles.find(x => x.text === "Default");
                if (defaultEditorProfile) {
                    this.localUser.editorProfileId = defaultEditorProfile.value;
                }
            }
            this.$emit("setDefaultValues", this.localUser.editorProfileId);
        });
    }

    setTimeZone() {
        if (this.localUser.timeZone && this.localUser.timeZone.length > 0) {
            const timeZone = this.timeZones.find(x => x.id === this.localUser.timeZone);
            if (timeZone) {
                this.selectedTimeZone.displayName = timeZone.displayName;
                this.selectedTimeZone.id = timeZone.id;
                return;
            }
        }

        const browserLocation = Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[1];
        const timeZone = this.timeZones.find(x => x.displayName.includes(browserLocation));
        if (timeZone) {
            this.selectedTimeZone.displayName = timeZone.displayName;
            this.selectedTimeZone.id = timeZone.id;
        }
    }

    emitData() {
        this.localUser.timeZone = this.selectedTimeZone.id;
        this.$emit("detailsUpdated", JSON.stringify(this.localUser));
    }

    setState(state:boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "UserDetails", state: state });
    }

    togglePasswordVisibility() {
        if (this.passwordFieldType === "password") {
            this.passwordFieldType = "text";
        } else {
            this.passwordFieldType = "password";
        }
    }

    sendResetPassEmail() {
        resetPassword(this.user.email, "Reset password from support").then(response => {
            response.mailSent ? this.emailResp = i18n.t("users.mailSent") : this.emailResp = i18n.t("login.mailNotSent");
            response.somethingBadHappen ? this.emailResp = i18n.t("users.incorectEmail") : this.editPassword = false;
        });
    }

    selectRole(roleName: string) {
        const roleSelected = this.localUser.roles ? this.localUser.roles.some(role => role === roleName) : false;
        if (roleSelected) {
            this.localUser.roles = this.localUser.roles.filter(role => role !== roleName);
            return;
        }

        const role = this.availableRoles.find(role => role === roleName);
        if (role) {
            this.localUser.roles.push(role);
        }
    }
}
